import { Branch } from './branch.model';
import { BusinessUnit } from './business_unit.model';
import { BillingType } from './billing-type.model';
import { Division } from './division.model';
import { ProductType } from './product_type.model';
import { Subfamily } from './subfamily.model';

export class Product {
  id?: number;

  product_type_id?: number;
  subfamily_id?: number;
  division_id?: number;
  business_unit_id?: number;
  branch_id?: number;

  code?: string;
  label?: string;
  name?: string;

  resp_onesi?: string;
  conso_it_axes_level_1?: string;
  conso_it_axes_level_2?: string;

  offer?: string;
  billing_type_id?: number;
  class?: string;
  subclass?: string;
  sub_category?: string;
  sub_category_type?: string;
  billing_unit?: string;

  rea_n_min_1?: number;
  price_bu_n?: number;
  qty_bu_n?: number;
  revenue_bu_n?: number;
  price_pc_n_vs_bu_n?: number;
  qty_pc_n_vs_bu_n?: number;
  revenue_pc_n_vs_bu_n?: number;
  price_pc_n?: number;
  qty_pc_n?: number;
  revenue_pc_n?: number;
  price_bu_n_plus_1_vs_pc_n?: number;
  qty_bu_n_plus_1_vs_pc_n?: number;
  revenue_bu_n_plus_1_vs_pc_n?: number;
  price_bu_n_plus_1?: number;
  revenue_bu_n_plus_1?: number;
  qty_bu_n_plus_1?: number;
  com_pc_n?: string;
  com_bu_n_plus_1?: string;

  product_entity_owner?: string;
  is_digital?: boolean;
  bu_entity?: string;

  subfamily?: Subfamily;
  division?: Division;
  business_unit?: BusinessUnit;
  branch?: Branch;
  product_type?: ProductType;
  billing_type?: BillingType;

  constructor(data = {}) {
    Object.assign(this, data);

    if (this.subfamily) { this.subfamily = new Subfamily(this.subfamily); }
    if (this.division) { this.division = new Division(this.division); }
    if (this.business_unit) { this.business_unit = new BusinessUnit(this.business_unit); }
    if (this.branch) { this.branch = new Branch(this.branch); }
    if (this.billing_type) { this.billing_type = new BillingType(this.billing_type); }
    if (this.product_type) { this.product_type = new ProductType(this.product_type); }
  }
}
